import { useReducer, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs';
import { toast } from 'react-toastify';
import {
  GET_CUSTOMER_EXPIRY_URL,
  GENIATECH_GET_USER_INFORMATION_URL,
} from '../../services/api/accounts/AccountsUrl';
import * as types from '../../constants/types/accounts/AccountsTypes';
import { AccountsReducer } from '../../reducers/accounts/AccountsReducer';
import { GET_LOGGED_IN_USER_URL } from '../../services/api/user/UserUrl';
import Helpers from '../../utils/Helpers';
import { USAGE_HISTORY_URL } from '../../services/api/overview/usage-history/UsagehistoryUrl';

// eslint-disable-next-line import/prefer-default-export
export const UseAccounts = () => {
  const [state, dispatch] = useReducer(AccountsReducer, {
    isLoading: false,
    isError: false,
    accounts: [],
    usage: [],
    expiry: null,
  });

  const fetchUserAccounts = async () => {
    dispatch({
      type: types.FETCH_STARTS,
      payload: true,
    });

    if (sessionStorage.getItem('email')) {
      const data = {
        email: `${sessionStorage.getItem('email')}`,
      };
      try {
        const response = await axios.post(
          `${GENIATECH_GET_USER_INFORMATION_URL}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
          },
        );
        dispatch({
          type: types.FETCHED_ACCOUNTS,
          payload: response.data,
        });
      } catch (e) {
        dispatch({
          type: types.FETCH_FAILURE,
          payload: false,
        });
      }
    } else {
      try {
        const response = await axios.get(`${GET_LOGGED_IN_USER_URL}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        });
        try {
          const newData = {
            email: response.data.email,
          };
          const res = await axios.post(
            `${GENIATECH_GET_USER_INFORMATION_URL}`,
            newData,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
              },
            },
          );

          dispatch({
            type: types.FETCHED_ACCOUNTS,
            payload: res.data,
          });
        } catch (e) {
          dispatch({
            type: types.FETCH_FAILURE,
            payload: false,
          });
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
    }
  };

  const getUsageHistory = async () => {
    if (sessionStorage.getItem('email')) {
      dispatch({ type: types.START_FETCHING_USAGE });

      const data = {
        email: `${sessionStorage.getItem('email')}`,
      };

      try {
        const response = await axios.post(
          `${GENIATECH_GET_USER_INFORMATION_URL}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
          },
        );

        const allUsage = [];

        for (const user of response.data) {
          const userData = {
            startdate: Helpers.getSevenDaysAgoDate(),
            enddate: Helpers.getTodaysDate(),
            mac: user.username,
          };

          try {
            const res = await axios.post(`${USAGE_HISTORY_URL}`, userData, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
              },
            });

            if (res.data.status === true) {
              allUsage.push(res.data.items);
            } else {
              allUsage.push([]);
            }
          } catch (e) {
            allUsage.push([]);
          }
        }

        dispatch({
          type: types.FETCHED_USAGE,
          payload: allUsage,
        });
      } catch (e) {
        dispatch({ type: types.STOP_FETCHING_USAGE });
      }
    } else {
      dispatch({ type: types.START_FETCHING_USAGE });

      try {
        const get = await axios.get(`${GET_LOGGED_IN_USER_URL}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        });

        if (get.data) {
          const data = {
            email: get.data.email,
          };

          try {
            const response = await axios.post(
              `${GENIATECH_GET_USER_INFORMATION_URL}`,
              data,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                },
              },
            );

            const allUsage = [];

            for (const user of response.data) {
              const userData = {
                startdate: Helpers.getSevenDaysAgoDate(),
                enddate: Helpers.getTodaysDate(),
                mac: user.username,
              };

              try {
                const res = await axios.post(`${USAGE_HISTORY_URL}`, userData, {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                  },
                });

                if (res.data.status === true) {
                  allUsage.push(res.data.items);
                } else {
                  allUsage.push([]);
                }
              } catch (e) {
                allUsage.push([]);
              }
            }

            dispatch({
              type: types.FETCHED_USAGE,
              payload: allUsage,
            });
          } catch (e) {
            dispatch({ type: types.STOP_FETCHING_USAGE });
          }
        } else {
          dispatch({ type: types.STOP_FETCHING_USAGE });
        }
      } catch (e) {
        dispatch({ type: types.STOP_FETCHING_USAGE });
      }
    }
  };

  const getExpiration = async () => {
    if (`${sessionStorage.getItem('email')}`) {
      const data = {
        email: `${sessionStorage.getItem('email')}`,
      };
      try {
        const response = await axios.post(
          `${GENIATECH_GET_USER_INFORMATION_URL}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
          },
        );
        if (response.data) {
          // eslint-disable-next-line array-callback-return
          response.data.map((respo) => {
            const mac = {
              // action: 'getUserExpiration',
              mac_id: respo.username,
            };

            axios
              .post(`${GET_CUSTOMER_EXPIRY_URL}`, mac, {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                },
              })
              .then((resp) => {
                if (resp.data.debtor_no) {
                  // const last = resp.data[resp.data.length - 1];
                  dispatch({
                    type: types.GET_EXPIRY_DATE,
                    // payload: last.Tran_date
                    payload: resp.data.debtor_no,
                  });
                }
              })
              .catch((err) => {
                if (err) {
                  toast.info(`Unable to get user's expiry date`);
                }
              });
          });
        } else {
          toast.info('unable to get user information');
        }
      } catch (e) {
        toast.info('Something went wrong');
      }
    }
  };

  useEffect(() => {
    fetchUserAccounts();
    getUsageHistory();
    getExpiration();
  }, []);
  return [state];
};
